
import React from 'react'
import backsplash from './ImagesAndIcons/ContramaticLogoAnimatedWordsFirstLGray.gif';



import {Container, Fade, Link, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import ModuleTabs from "./AppTabs/ModuleTabs";
import {useSelector} from "react-redux";

import {NavLink, Router} from "react-router-dom";
import ManageWorkTabs from "./AppTabs/ManageWorkTabs";


function Home2() {

    return(

        <Box             sx={{
            lp: 0,
            lm: 0,
        }}>

        <Box
            className = "homeMui"

            sx={{
                    width: 1,
                    height: '20px',
                    }}
                >
            </Box>
            <div>
            {    useSelector((state) => state.mainSlc.value.manageWorkTabs) === true
           && <ManageWorkTabs/>}
            {    useSelector((state) => state.mainSlc.value.moduleTabs)
                && <ModuleTabs/>}
            </div>

<Box sx={{height: '100px'}}/>
            <Container disableGutters>
                <NavLink to="/Work">
                    <Box
                        component="img"
                        src={backsplash}
                        sx={{
                            display: "block",     // ensures no inline spacing
                            mx: "auto",           // auto margins on left and right = horizontal centering
                            maxWidth: "100%",     // optional: keeps image from overflowing container
                        }}
                    />
                </NavLink>
            </Container>
            <br/>
            <br/>
            <br/>
            <br/>
            <Typography sx={{fontSize: 14, textAlign: 'center'}} >Patent Pending</Typography>
         </Box>

    )
}

export default Home2